import { useState, useEffect } from "react";
import { Routes, Route, ScrollRestoration } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import ScrollToTop from "./components/ScrollToTop";
import LoginScreen from "./components/LoginScreen.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
import LandingPage from "./components/LandingPage.jsx";
import AboutUsPage from "./components/AboutUsPage.jsx";
import ContactUsPage from "./components/ContactUsPage.jsx";
import ProjectsPage from "./components/ProjectsPage.jsx";
import ProjectDetailPage from "./components/ProjectDetailPage.jsx";
import PrivacyPolicy from "./components/PrivacyPolicy.jsx";

const EXPIRATION_DAYS = 7;
const MS_IN_DAY = 86400000;

export default function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const temporarilyBypassLogin = true;
    if (temporarilyBypassLogin) {
      localStorage.setItem("authenticated", "true");
      localStorage.setItem("authenticatedAt", Date.now().toString());
      setAuthenticated(true);
      return;
    }

    const auth = localStorage.getItem("authenticated");
    const timestamp = localStorage.getItem("authenticatedAt");

    if (auth === "true" && timestamp) {
      const age = Date.now() - parseInt(timestamp, 10);
      if (age < EXPIRATION_DAYS * MS_IN_DAY) {
        setAuthenticated(true);
      } else {
        localStorage.removeItem("authenticated");
        localStorage.removeItem("authenticatedAt");
      }
    }
  }, []);

  if (!authenticated) {
    return (
      <Routes>
        <Route
          path="*"
          element={<LoginScreen onAuthenticated={() => setAuthenticated(true)} />}
        />
      </Routes>
    );
  }

  return (
    <>
      <Helmet>
        <html lang="en" />
        <script
          async
          defer
          data-website-id="215983c9-a894-4125-ae6b-b419b55cf474"
          src="https://metrics.covepoint.com/script.js"
        ></script>
      </Helmet>

      <ScrollToTop  />

      <div className="font-roboto min-h-screen flex flex-col">
        <header>
          <Header
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        </header>

        <main className="flex-grow" id="main-content">
          <Routes>
           
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:slug" element={<ProjectDetailPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </main>

        <footer>
          <Footer />
        </footer>
      </div>
    </>
  );
}
